export const PATH = '/start-up';
